const messages = {
  de: {
    beginReservation: 'Beginn Reservation',
    lengthOfTime: 'Dauer',
    weeks: 'Woche | Wochen',
    More: 'Mehr',
    contactUsDirectlyForLargerMoves:
      'Für grössere Umzüge mit einem Büro oder einer Bibliothek etc. nehmen Sie bitte direkt mit uns {0} auf.',
    Contact: 'Kontakt',
    contact: 'Kontakt',
    next: 'Weiter',

    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    '2 weeks': '2 Wochen',
    '3 weeks': '3 Wochen',
    '4 weeks': '4 Wochen',
    '5 weeks': '5 Wochen',
    '6 weeks': '6 Wochen',
    '7 weeks': '7 Wochen',
    '8 weeks': '8 Wochen',

    pleaseSelectYourItems: 'Bitte wählen Sie Ihre Artikel',
    notSureCalculateYourNeeds: 'Nicht sicher? {0}',
    calculateNeeds: 'Berechnen Sie hier Ihren Bedarf',
    youShouldRentXXBoxes: 'Sie sollten  <span>{amount}</span> Boxen leihen.',

    deliverBoxToHome: 'Boxen liefern lassen',
    pickUpBoxesYourself: 'Boxen selbst abholen',
    shippingAddress: 'Lieferadresse',
    beforeMove: 'vor Umzug',
    pickupAddress: 'Abholadresse',
    afterMove: 'nach Umzug',
    Address: 'Strassenname',
    zipCode: 'PLZ',
    City: 'Stadt',
    'Additional Information': 'Zusätzliche Infos',
    sameDeliveryAddressBeforeAndAfterMoving: 'Lieferadresse entspricht Abholadresse nach Umzug',
    pleaseEnterYourAddress: 'Bitte geben Sie Ihre Adresse ein:',
    pleaseEnterYourZipCode: 'Bitte geben Sie Ihre Postleitzahl ein:',

    yourPersonalData: 'Ihre persönlichen Daten',
    Salutation: 'Anrede',
    'First Name': 'Vorname',
    'Last Name': 'Name',
    Company: 'Firma',
    'Email address': 'E-Mail Adresse',
    Mobile: 'Mobiltelefon',
    Notes: 'Notizen',
    getYourDataFromSwisspass: 'Holen Sie sich Ihre Daten von swisspass',
    swisspassID: 'Swiss Pass ID',
    'Load data': 'Daten laden',
    'Do you have voucher?': 'Haben Sie einen Gutschein?',
    'Voucher Code': 'Gutschein Code',
    'Apply Voucher': 'Gutschein einlösen',
    'I accept the': 'Ich akzeptiere die {0}',
    'Terms and Conditions': 'Allgemeinen Geschäftsbedingungen',

    Summary: 'Zusammenfassung',
    'Reserve and go to payment': 'zur Zahlung',

    // Country Selector
    Switzerland: 'Schweiz',
    Germany: 'Deutschland',
    Austria: 'Österreich',
    Liechtenstein: 'Liechtenstein',

    // STEP 4
    swissPassError: 'Es scheint, dass etwas schief gelaufen ist. Bitte versuchen Sie es später.',
    Country: 'Land',
    HERR: 'Herr',
    FRAU: 'Frau',
    '---': '---',
    fillInIfBusinessOrder: 'Bitte ausfüllen, wenn es sich um eine geschäftliche Bestellung handelt.',
    choose: 'auswählen', // Button on map to select store
    'Remove data': 'Daten entfernen',

    // STEP 5
    'Contact Information': 'Kontaktinformationen',
    'Delivery details': 'Lieferadresse',
    'Your Products': 'Ihre Artikel',
    billingAddress: 'Rechnungsadresse',
    'Pickup place details': 'Details zum Abholort',
    Date: 'Datum',

    // bottom bar
    from: 'ab', // Price from
    for: 'für',
    article: '{amount} Artikel | {amount} Artikel',

    // MAP
    'User Location': 'Ihr Standort',

    // User needs calculator
    calculator: {
      numberOfRooms: 'Anzahl Zimmer',
      numberOfAdults: 'Anzahl Erwachsener',
      numberOfYears: 'Anzahl Jahre an diesem Ort',
    },

    // Payment
    'Payment Form': 'Kasse',

    // Thank you page
    'Thank You!': 'Danke!',
    'Your reservation was successful.': 'Ihre Buchung war erfolgreich.',
    'Please check your email with the reservation details.':
      'Bitte überprüfen Sie Ihre E-Mail mit den Reservierungsdetails.',
    'Your reservation number is #{number}': 'Ihre Buchungsnummer lautet R#{number}',
    'After changing any of this value your basket will be cleared.':
      'Nachdem Sie einen dieser Werte geändert haben, wird Ihr Warenkorb geleert.',
    'Please confirm your location:': 'Bitte bestätigen<br />Sie Ihren Standort:',
  },
}

export default messages
